// Open collapsible section via URL parameter — Cadi Jewelry
document.addEventListener('DOMContentLoaded', function () {
  const params = new URLSearchParams(window.location.search);
  const openParam = params.get('open');
  if (!openParam) return;

  const map = {
    'custom-jewelry':  'custom jewelry',
    'size-guide':      'size guide',
    'orders':          'orders',
    'payments':        'payments & security',
    'shipping':        'shipping',
    'returns':         'returns & exchanges',
    'warranty':        'warranty',
    'shop-policy':     'shop policy',
    'qa':              'q/a',
    'track-order':     'track your order',
    'products':        'products'
  };

  const targetText = map[openParam.toLowerCase().trim()];
  if (!targetText) return;

  const triggers = document.querySelectorAll('.wt-collapse__trigger__title');
  triggers.forEach(function (trigger) {
    const triggerText = trigger.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
    if (triggerText === targetText) {
      const button = trigger.closest('.wt-collapse__trigger');
      if (!button) return;
      // The live open state is on <collapsible-section>; data-open on the trigger is only the initial render.
      const section = button.closest('collapsible-section');
      const isAlreadyOpen = (section || button).getAttribute('data-open') === 'true';
      if (!isAlreadyOpen) button.click();
      setTimeout(function () {
        const offset = 100;
        const top = button.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }, 350);
    }
  });
});